import { render, staticRenderFns } from "./listInvoiceFranchise.vue?vue&type=template&id=65da751c"
import script from "./listInvoiceFranchise.vue?vue&type=script&lang=js"
export * from "./listInvoiceFranchise.vue?vue&type=script&lang=js"
import style0 from "./listInvoiceFranchise.vue?vue&type=style&index=0&id=65da751c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports